import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
// slices
import authSlice from "./slices/authSlice";
import bannerSlice from "./slices/bannerSlice";
import blogSlice from "./slices/blogSlice";
import bookingSlice from "./slices/bookingSlice";
import categorySlice from "./slices/categorySlice";
import contactSlice from "./slices/contactSlice";
import eventBookingSlice from "./slices/eventBookingSlice";
import eventSlice from "./slices/eventSlice";
import mediaSlice from "./slices/gallerySlice";
import menuSlice from "./slices/menuSlice";
import newsSlice from "./slices/newsSlice";
import projectSlice from "./slices/projectSlice";
import serviceSlice from "./slices/serviceSlice";
import teamSlice from "./slices/teamSlice";
import testimonialSlice from "./slices/testimonialSlice";
import userSlice from "./slices/userSlice";

import eventGallerySlice from "./slices/eventGallerySlice";
import hotelRoomSlice from "./slices/hotelRoomSlice";
import packageSlice from "./slices/packageSlice";
import roomBookingSlice from "./slices/roomBookingSlice";
import roomRateSlice from "./slices/roomRateSlice";
import roomTypeSlice from "./slices/roomTypeSlice";
import statSlice from "./slices/statSlice";

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  team: teamSlice,
  category: categorySlice,
  blog: blogSlice,
  testimonial: testimonialSlice,
  banner: bannerSlice,
  menu: menuSlice,
  eventbooking: eventBookingSlice,
  service: serviceSlice,
  news: newsSlice,
  project: projectSlice,
  media: mediaSlice,
  event: eventSlice,
  booking: bookingSlice,
  stat: statSlice,
  roomType: roomTypeSlice,
  hotelRoom: hotelRoomSlice,
  eventGallery: eventGallerySlice,
  roomBooking: roomBookingSlice,
  package: packageSlice,
  contact: contactSlice,
  roomRate: roomRateSlice,
});

export default rootReducer;
